/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Menu from '../../../components/Menu'

import { get } from '../../../services/http'
import { notify } from '../../../components/Toast'

import ReactPaginate from 'react-paginate'

import { ToastContainer } from 'react-toastify'

import foodIcon from '../../../assets/svg/orderIcon.svg'
import Table from '../../../components/OrderList/'

export default function index() {
  document.title = 'لیست سفارشات'

  const [orders, setOrders] = useState([])
  const [ordersCount, setOrdersCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [name, setName] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/order?token=${token}`)
      .then(response => {
        setOrders(response.data.data)
        setTotalPage(response.data.pages)
        setOrdersCount(response.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/order?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setOrders(response.data.data)
      setTotalPage(response.data.pages)
      setOrdersCount(response.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const searchBtnHandler = () => {
    get(`/api/admin/order/search/${name}?token=${token}`)
    .then(response => {
      setOrders(response.data.data)
      setTotalPage(0)
      setOrdersCount(response.data.data.length)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const getAllDataHandler = () => {
    get(`/api/admin/order?token=${token}`)
      .then(response => {
        setOrders(response.data.data)
        setTotalPage(response.data.pages)
        setOrdersCount(response.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'allorder'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='foodIcon' />
              </div>
              <div className='text'>
                سفارشات
              </div>
            </div>

            <div className="left">
              <button onClick={getAllDataHandler}>دریافت کل اطلاعات</button>
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">شماره موبایل سفارش دهنده : </label>
              <input type="text" onChange={e => setName(e.target.value)}/>
              <button onClick={searchBtnHandler}>جستجو</button>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                تعداد کل سفارشات
              </div>
              <div className="left">
                {ordersCount}
              </div>
            </div>

            <Table data={orders} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
